export default __webpack_public_path__ + "static/media/sd_toggle_off.6f5b74b2.svg";